module.exports = __webpack_public_path__ + "static/media/daria.00027237.jpg";